import { Icon } from '@branchjs/neo-components';
import { cx } from '@emotion/css';
import { draggableMultiValueLabelStyles as css } from 'client/js/common/components/core/PureQueryBuilder/DraggableCompareBy/styles';
import type { IndexedOption } from 'client/libraries/branch-neo-next/OrderedSelectDropdown/types';
import React from 'react';
import { components } from 'react-select';
import type { MultiValueGenericProps } from 'react-select';

const DraggableMultiValueLabel = (props: MultiValueGenericProps<IndexedOption>) => {
  return (
    <div className={css.container}>
      <Icon className={cx(css.dragIcon, 'drag-icon')}>drag_indicator</Icon>
      <div className={css.labelValue}>
        <components.MultiValueLabel {...props} />
      </div>
    </div>
  );
};

export default DraggableMultiValueLabel;
